import {
  CALL_OUTBOUND_PREAUTH_REQUEST,
  CALL_OUTBOUND_PREAUTH_SUCCESS,
  CALL_OUTBOUND_PREAUTH_FAILURE,
} from "./actionType";

export const callOutboundPreauthRequest = (payload) => ({
  type: CALL_OUTBOUND_PREAUTH_REQUEST,
  payload,
});

export const callOutboundPreauthSuccess = (response) => ({
  type: CALL_OUTBOUND_PREAUTH_SUCCESS,
  payload: response,
});

export const callOutboundPreauthFailure = (error) => ({
  type: CALL_OUTBOUND_PREAUTH_FAILURE,
  payload: error,
});
